import { ProcessElementParameters } from "./ProcessElementParameters";

export interface ProcessInstanceDetails {
    instanceDetails: InstanceDetails;
    processDetails: ProcessDetails;
}

export interface InstanceDetails {
    id: number;
    parentId?: number;
    parentName: string;
    executionId: string;
    processGuid: string;
    rootProcessGuid?: string;
    processVersion: number;
    state: string;
    steps: ProcessInstanceStepReferenceViewModel[];
    stepDataUri?: string;
    startTimeUtc: string;
    endTimeUtc?: string;
    duration?: string;
    environment: string;
    agentGroup: string;
    agent: string;
    exception?: string;
    userName: string;
    triggerName: string;
    processParameters?: Record<string, string>;
    processReturnValues?: string[];
    hasLoggedSteps?: boolean;
}

export interface ProcessDetails {
    bpmn: string;
    elementParameters: ProcessElementParameters[];
}

export interface ProcessInstanceStepReferenceViewModel {
    id: number;
    state: string;
    stepId: string;
    loopParameters: unknown[];
}

export enum ExecutionState {
    Started = 5,
    FinishedAsZombie = 8,
    TerminatedByUser = 9,
    Exception = 12,
    Finished = 13,
}

export const FailedStates = [
    ExecutionState.FinishedAsZombie,
    ExecutionState.TerminatedByUser,
    ExecutionState.Exception,
];
